import { render, staticRenderFns } from "./WeChatClient.vue?vue&type=template&id=c94ba68e&scoped=true&"
import script from "./WeChatClient.vue?vue&type=script&lang=js&"
export * from "./WeChatClient.vue?vue&type=script&lang=js&"
import style0 from "./WeChatClient.vue?vue&type=style&index=0&id=c94ba68e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c94ba68e",
  null
  
)

export default component.exports